import React, { useEffect } from "react";
import Header from "./Header";
import Hero from "./Hero";
import Projects from "./Projects";
import AboutHero from "./AboutHero";
import Footer from "./Footer";
import Testimonials from "./Testimonials";
import ScrollArrow from "./ScrollArrow";

export default function Home() {
  useEffect(() => {
    // Intersection Observer for animations with reset functionality
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add visible class when element becomes visible
            entry.target.classList.add("visible");
          } else {
            // Remove visible class when element is not visible (for reset functionality)
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.08, // Trigger when 8% of element is visible
        rootMargin: "0px 0px -100px 0px", // Add some margin to trigger earlier/later
      }
    );

    // Additional scroll listener to reset all animations when at top
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isAtTop = scrollY < 50; // Consider "top" as first 50px

      if (isAtTop) {
        // Reset all animations when user scrolls back to top (except Hero)
        const mainContentChildren = document.querySelectorAll(
          ".main-content > *:not(:first-child)"
        );
        mainContentChildren.forEach((child) => {
          child.classList.remove("visible");
        });
      }
    };

    // Observe all direct children of main-content
    const mainContentChildren = document.querySelectorAll(".main-content > *");
    mainContentChildren.forEach((child) => {
      observer.observe(child);
    });

    // Add scroll listener for top reset
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup function
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Header />
      <div className="main-content">
        <Hero />
        <Projects />
        <AboutHero />
        <Testimonials />
      </div>
      <Footer />
      <ScrollArrow />
    </>
  );
}
